export const RECAPTCHA_KEY =
  process.env.NODE_ENV === 'production' ? '#{ReCaptchaSiteKey}' : '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
